import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Extract error message from API error response
 * Handles both simple string errors and Pydantic validation errors (array of objects)
 * @param {Error} error - The error object from axios
 * @param {string} defaultMsg - Default message if no specific error found
 * @returns {string} - Human readable error message
 */
export function getErrorMessage(error, defaultMsg = 'Une erreur est survenue') {
  const detail = error?.response?.data?.detail;
  
  if (!detail) return defaultMsg;
  
  if (typeof detail === 'string') {
    return detail;
  }
  
  if (Array.isArray(detail) && detail.length > 0) {
    // Pydantic validation errors
    return detail.map(e => e.msg || e.message || String(e)).join(', ');
  }
  
  if (typeof detail === 'object') {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  
  return defaultMsg;
}
